import {
  init_react_import
} from "./chunk-65BGW52G.mjs";

// variables/spacing.ts
init_react_import();
var BASE = 8;

export {
  BASE
};
//# sourceMappingURL=chunk-IBEWOW4A.mjs.map